// extracted by mini-css-extract-plugin
export default {"row":"styles_row__oy9mx","buttons":"styles_buttons__GVCpr","cancel":"styles_cancel__Ifs8c","delete":"styles_delete__fCT+o","select":"styles_select__U7nTW"};